import React, { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import {
  FaWhatsapp,
  FaFileMedical,
  FaNotesMedical,
  FaHospital,
  FaSimplybuilt,
  FaBuilding,
  FaIdBadge,
  FaClinicMedical,
} from 'react-icons/fa';
import { MdError, MdDateRange, MdChat } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import getCep from '../../services/cep';
import Input from '../Input';
import Button from '../Button';
import Loader from '../Loader';
import MaskedInput from '../MaskedInput';
import { ResponseMessage } from '../ResponseMessage';
import getValidationErrors from '../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../SelectSimple';
import Whatsapp from '../WhatsAppCompartilhar';

import api from '../../services/api';
import { recaptchaKey, urlWebsite, eventName } from '../../config';

interface IRecoverFormData {
  name: string;
  email: string;
  password?: string;
  birth_date: string;
  company: string;
  position: string;
  category_id: string;
  phone: string;
  captcha: string;
  document_number: string;
}

interface ICaptcha {
  getValue(): string;
}

const FormContainer = ({ context = {} }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };

  const getCepFromApi = async (value: string): Promise<void> => {
    const cepResponse = await getCep(value);

    if (!cepResponse.error) {
      formRef?.current?.setFieldValue('address', cepResponse.logradouro);
      formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
      formRef?.current?.setFieldValue('city', cepResponse.localidade);
      formRef?.current?.setFieldValue('state', cepResponse.uf);
    }
  };

  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);

    data.birth_date = data.birth_date
      ? data.birth_date.toString().replace(/[^0-9/]/g, '')
      : '';
    try {
      formRef.current?.setErrors({});

      const shape = {
        name: Yup.string().required('O campo Nome Completo é obrigatório'),
        email: Yup.string().email().required('O campo Email é obrigatório'),
        phone: Yup.string().required('O campo Telefone é obrigatório'),
        zipcode: Yup.string().required('O campo CEP é obrigatório'),
        address: Yup.string().required('O campo Endereço é obrigatório'),
        especialidade: Yup.string().required('O campo Categoria é obrigatório'),
        neighborhood: Yup.string().required('O campo Bairro é obrigatório'),
        state: Yup.string().required('O campo Estado é obrigatório'),
        city: Yup.string().required('O campo Cidade é obrigatório'),
        country: Yup.string().required('O campo País é obrigatório'),

        birth_date: Yup.string()
          .min(10, 'min 10 Preecha a Data de Nascimento')
          .max(10, 'max 10 Preecha a Data de Nascimento')
          .required('Data de Nascimento obrigatória'),
      };
      data.phone = data.phone.toString().replace(/[^0-9]/g, '');
      data.birth_date.toString().replace(/[^0-9/]/g, '');
      data.document_number.toString().replace(/[^0-9]/g, '');
      const schema = Yup.object().shape(shape);

      await schema.validate(data, { abortEarly: false });

      const captchaValue =
        getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
        false;

      const response = await api.post(`/signup`, {
        ...data,

        captcha: captchaValue,
      });

      // setSuccess(true);
      setLoading(false);
      window.location.href = '/inscricao/sucesso';
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      setErrorMessage([
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Erro ao gerar seu cadastro',
      ]);
    }
    setLoading(false);
  };

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside>
        {success ? (
          <ResponseMessage
            active
            type="clean"
            title=""
            description={
              <p style={{ color: '#fff' }}>
                <h2 className="titleH2" style={{ color: '#fff' }}>
                  {' '}
                  Obrigado!{' '}
                </h2>
                <p style={{ color: '#fff' }}>
                  Sua inscrição no
                  {` `}
                  {eventName}
{' '}
já está confirmada.
</p>
                <br />
                <Link to="login">
                  <button className="defaultButton" type="button">
                    Acessar
                  </button>
                </Link>
                <br />
                Aproveite e indique para seus amigos!
                <Whatsapp
                  text={`Olá! Acabei de me inscrever na ${eventName}. Acredito que você irá gostar de participar desse evento! Inscreva-se pelo link: ${urlWebsite}`}
                  number=""
                  message="Compartilhe!"
                />
              </p>
            }
          />
        ) : (
          <Form
            ref={formRef}
            onSubmit={handleNewLogin}
            initialData={{ country: 'Brasil', extra_1: 'Sim' }}
          >
            <div className="formBackground">
              <Input icon={FiUser} name="name" placeholder="Nome Completo" />

              <Input icon={FiMail} name="email" placeholder="E-mail" />

              <MaskedInput
                mask="999.999.999-99"
                name="document_number"
                placeholder="CPF"
              />

              <MaskedInput
                mask="99/99/9999"
                name="birth_date"
                placeholder="Data de Nascimento"
              />
              <MaskedInput
                mask="(99) 99999.9999"
                name="phone"
                placeholder="Telefone"
              />
              <SelectSimple
                options={[
                  { label: 'Sim', value: 'Sim' },
                  { label: 'Não', value: 'Não' },
                ]}
                name="extra_1"
                formRef={formRef}
                label="Telefone é Whatsapp?"
              />
              <SelectSimple
                options={[
                  { label: 'Estudante', value: 'Estudante' },
                  { label: 'Professor', value: 'Professor' },
                  { label: 'Outro', value: 'Outro' },
                ]}
                name="especialidade"
                formRef={formRef}
                label="Categoria"
              />

              <MaskedInput
                setCallback={getCepFromApi}
                mask="99999999"
                name="zipcode"
                placeholder="CEP"
              />
              <Input name="address" placeholder="Endereço" />
              <Input name="address_number" placeholder="Número / Apartamento" />
              <Input name="neighborhood" placeholder="Bairro" />
              <Input name="city" placeholder="Cidade" />
              <SelectSimple
                options={[
                  { label: 'Acre (AC)', value: 'AC' },
                  { label: 'Alagoas (AL)', value: 'AL' },
                  { label: 'Amapá (AP)', value: 'AP' },
                  { label: 'Amazonas (AM)', value: 'AM' },
                  { label: 'Bahia (BA)', value: 'BA' },
                  { label: 'Ceará (CE)', value: 'CE' },
                  {
                    label: 'Distrito Federal (DF)',
                    value: 'DF',
                  },
                  {
                    label: 'Espírito Santo (ES)',
                    value: 'ES',
                  },
                  { label: 'Goiás (GO)', value: 'GO' },
                  { label: 'Maranhão (MA)', value: 'MA' },
                  { label: 'Mato Grosso (MT)', value: 'MT' },
                  {
                    label: 'Mato Grosso do Sul (MS)',
                    value: 'MS',
                  },
                  { label: 'Minas Gerais (MG)', value: 'MG' },
                  { label: 'Pará (PA)', value: 'PA' },
                  { label: 'Paraíba (PB)', value: 'PB' },
                  { label: 'Paraná (PR)', value: 'PR' },
                  { label: 'Pernambuco (PE)', value: 'PE' },
                  { label: 'Piauí (PI)', value: 'PI' },
                  {
                    label: 'Rio de Janeiro (RJ)',
                    value: 'RJ',
                  },
                  {
                    label: 'Rio Grande do Norte (RN)',
                    value: 'RN',
                  },
                  {
                    label: 'Rio Grande do Sul (RS)',
                    value: 'RS',
                  },
                  { label: 'Rondônia (RO)', value: 'RO' },
                  { label: 'Roraima (RR)', value: 'RR' },
                  {
                    label: 'Santa Catarina (SC)',
                    value: 'SC',
                  },
                  { label: 'São Paulo (SP)', value: 'SP' },
                  { label: 'Sergipe (SE)', value: 'SE' },
                  { label: 'Tocantins (TO)', value: 'TO' },
                  { label: 'Não sou Brasileiro', value: 'Não sou Brasileiro' },
                ]}
                name="state"
                formRef={formRef}
                label="Estado"
              />
              <Input name="country" placeholder="País" />
              <p
                style={{
                  padding: '10px',
                  background: 'none',
                  margin: '5px auto',
                  color: '#fff',
                  fontSize: '12px',
                  textAlign: 'left',
                }}
              >
                Ao me cadastrar, afirmo que li e aceito a
{' '}
                <strong>
                  <Link
                    style={{ display: 'inline', color: '#fff' }}
                    to="/termos"
                    target="_BLANK"
                  >
                    Política de Privacidade
{' '}
                  </Link>
{' '}
                </strong>
                desta plataforma.
              </p>
              <div style={{ width: '100%', justifyContent: 'center' }}>
                <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />
              </div>
            </div>
            {errorMessage && (
              <Error>
                {errorMessage.map((item, index) => (
                  <div key={`error${index}`}>
                    <MdError />
                    {item}
                  </div>
                ))}
              </Error>
            )}
            <Button type="submit">CADASTRAR</Button>
          </Form>
        )}
      </aside>
    </>
  );
};

export default FormContainer;
